// Update.tsx
import React, { useState, useEffect } from 'react';
import { db, setDoc, getDoc, doc } from "../config/firebaseConfig";
import { soundService } from '../services/SoundService.ts';
import './Update.css';
import update_image01 from '../assets/images/update_01.png';

const targetDate = new Date('2025-05-06T20:00:00+09:00');

enum UpdateState {
  BACKUP_CONFIRM,
  BACKUP_PROGRESS,
  BACKUP_COMPLETE
}

interface UpdateProps {
  onClose: (props?: { openUpdateFail?: boolean }) => void;
}

const Update: React.FC<UpdateProps> = ({ onClose }) => {
  const [state, setState] = useState<UpdateState>(UpdateState.BACKUP_CONFIRM);
  const [backupCount, setBackupCount] = useState<number>(0);
  const [showContent, setShowContent] = useState(true);
  const [showOkButton, setShowOkButton] = useState(false);

  const fetchBackupCount = async () => {
    try {
      const summaryDoc = await getDoc(doc(db, "click-count", "summary"));
      if (summaryDoc.exists()) {
        const count = summaryDoc.data().count;
        setBackupCount(count);
      } else {
        setBackupCount(0);
      }
    } catch {
      setBackupCount(0);
    }
  };

  useEffect(() => {
    fetchBackupCount();
  }, []);

  const handleClick = async () => {
    try {
      const timestamp_unix = Date.now().toString();
      const timestamp = new Date().toISOString();
      await setDoc(doc(db, "click_logs", timestamp_unix), {
        timestamp: timestamp
      });
      await fetchBackupCount();
    } catch {
    }
  };

  const handleYesClick = async () => {
    if (state === UpdateState.BACKUP_CONFIRM) {
      setShowContent(false);
      setState(UpdateState.BACKUP_PROGRESS);
      
      if (process.env.REACT_APP_BACKUP_ENABLE === 'true' || process.env.REACT_APP_BACKUP_ENABLE === undefined || Date.now() < targetDate.getTime()) {
        await handleClick();
      }
      await new Promise(resolve => setTimeout(resolve, 100));
      setShowContent(true);
      const randomDelay = Math.floor(Math.random() * 1000) + 1000;
      await new Promise(resolve => setTimeout(resolve, randomDelay));
      setState(UpdateState.BACKUP_COMPLETE);
      soundService.playSound('error');
      setShowOkButton(false);
      setTimeout(() => {
        setShowOkButton(true);
      }, 100);
    }
  };

  const handleNoClick = () => {
    onClose();
  };

  const handleOkClick = () => {
    onClose({ openUpdateFail: true });
  };

  const getMessage = () => {
    const now = new Date();
    const displayBackupCount = now > targetDate ? "-----" : backupCount.toString();
    
    switch (state) {
      case UpdateState.BACKUP_CONFIRM:
        return `[警告]
        更新の実行前にバックアップの作成を推奨します。

        バックアップを行わずに更新を実行するとデータが破損する可能性があります。

        バックアップを作成しますか?
        現在のバックアップ作成数 ${displayBackupCount}`;
      case UpdateState.BACKUP_PROGRESS:
      case UpdateState.BACKUP_COMPLETE:
        return (
          <>
            バックアップデータを作成しています
            {state === UpdateState.BACKUP_COMPLETE && (
              <div className="message-text" style={{ marginTop: '20px' }}>
                失敗
              </div>
            )}
          </>
        );
    }
  };

  const renderButtons = () => {
    switch (state) {
      case UpdateState.BACKUP_CONFIRM:
        return (
          <>
            <button 
              className="btn-common message-text"
              onClick={handleYesClick}
            >
              はい(Y)
            </button>
            <button 
              className="btn-common message-text"
              onClick={handleNoClick}
            >
              いいえ(N)
            </button>
          </>
        );
      case UpdateState.BACKUP_COMPLETE:
        return showOkButton ? (
          <button 
            className="btn-common"
            onClick={handleOkClick}
          >
            OK
          </button>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className="windowContainer">
      <div className="leftPanel">
        <img 
          src={update_image01} 
          alt="Update" 
          className="update-image"
          style={{ 
            opacity: showContent ? 1 : 0
          }}
        />
      </div>
      <div className="rightPanel">
        <span 
          className="update-message-text message-text"
          style={{ 
            opacity: showContent ? 1 : 0
          }}
        >
          {getMessage()}
        </span>
        <div 
          className="buttonContainer"
          style={{ 
            opacity: showContent ? 1 : 0
          }}
        >
          {renderButtons()}
        </div>
      </div>
    </div>
  );
};

export default Update;